import type {Footer} from '~/types/legacy'
import type {Populated} from '~/types/populated'

export function useFooter() {
  const sdk = usePayloadSdk()

  const fetchFooter = async () => {
    const result = await sdk.findGlobal({
      slug: 'footerGlobal',
      depth: 2,
    })

    return result as Populated<Footer>
  }

  return {fetchFooter}
}
